import { Expose } from 'class-transformer';
import { DropdownModel } from '../../shared-features/models/dropdown-model';

export class AVLGroup extends DropdownModel {
  @Expose() id: number;
  @Expose() attributes?: any;
  @Expose() groupId?: number;
  @Expose() name?: string;

  constructor() {
    super();
  }

  get dropDownDisplayName(): string {
    return this.name;
  }
  get dropDownValue(): object {
    return this;
  }
}
